import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";

function PinnacleData() {
  const usePinnacleData = () =>
    useStaticQuery(graphql`
      query {
        ongoingJson(slug: { eq: "the-pinnacle-ra-puram-chennai" }) {
          id
          is_active
          is_custom
          ribbon_text
          title
          slug
          rera
          tagline
          banner {
            childImageSharp {
              fluid(maxWidth: 1920) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          brouchureUrl
          callUsNumber
          video {
            type
            link
          }
          short_desc
          footer_desc
          sections {
            gallery {
              title
              images {
                childImageSharp {
                  fluid(maxWidth: 1920) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
            project_updates {
              title
              images {
                childImageSharp {
                  fluid(maxWidth: 1920) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              videos {
                type
                thumbnail {
                  childImageSharp {
                    fluid(maxWidth: 1920) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                link
              }
            }
          }
        }
      }
    `);
  const data = usePinnacleData();
  const projectData = data.ongoingJson;
  return [projectData];
}

export default PinnacleData;
